<template>
  <div class="content_locations">
    <div class="text-center" style="padding:40px 0 0; margin-bottom: 20px;">
      <h2 style="
        color:#710e15;
        font-weight:bold;
        font-size:2em;
      ">
        Jeffrey's has two locations to serve you!
      </h2>
    </div>

    <div class="left" style="width:450px; padding:20px;">
      <h2 class="order-online">
        <a href="https://jeffreyshamburgers.alohaorderonline.com/Engage.aspx?#/engage/ordering/directlink/MQ==/MQ==">
          <span class="cta-wrap">
            <span class="cta">Order Online</span>
            <span class="cta-location">Menlo Park</span>
          </span>
        </a>
      </h2>

      <adress class="block order-online mb-2">
        <a class="bold" href="tel:650-322-1959">650.322.1959</a>
        <div>Hours : 11am - 8pm Daily</div>
        <div>888 El Camino Real, <strong>Menlo Park</strong>, CA 94025</div>
      </adress>

      <div class="line-horizontal mb-2"></div>

      <div id="map" class="map">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3498.166583980588!2d-122.18249632372488!3d37.4530080015945!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fa4b1f617a541%3A0xebedcccc71784fd3!2sJeffrey&#39;s%20Hamburgers!5e0!3m2!1sen!2sus!4v1680659689902!5m2!1sen!2sus"
          width="100%"
          height="250"
          style="border:0;"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>

    <div class="line_vertical"></div>

    <div class="left" style="width:430px; padding:20px;">
      <h2 class="order-online mb-3">
        <a href="https://jeffreyshamburgers.alohaorderonline.com/Engage.aspx?#/engage/ordering/directlink/Mg==/MQ==">
          <span class="cta-wrap">
            <span class="cta">Order Online</span>
            <span class="cta-location">San Mateo</span>
          </span>
        </a>
      </h2>

      <adress class="block order-online mb-2">
        <a class="bold" href="tel:650-348-8698">650.348.8698</a>
        <div>Hours : 11am - 8pm Daily</div>
        <div>42 South B Street, <strong>San Mateo</strong>, CA 94401</div>
      </adress>

      <div class="line-horizontal mb-2"></div>

      <div id="map2" class="map">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d604.7408243351382!2d-122.32459309209318!3d37.56735884564019!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808f7648fc439427%3A0x68d70f0bcb07025!2sJeffrey&#39;s%20Hamburgers!5e0!3m2!1sen!2sus!4v1680659628278!5m2!1sen!2sus"
          width="100%"
          height="250"
          style="border:0;"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>

      <div style="margin:0px 20px 0 0;">
        <a href="/assets/images/mapview.jpg" target="_blank">
          <img src="/assets/images/parking.png" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Locations',
};
</script>
